// ManageListingsModal.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { Modal, Button, Spinner, Alert } from 'react-bootstrap';
import { getAuth } from 'firebase/auth';
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs
} from 'firebase/firestore';
import ListingEditorModal from './ListingEditorModal';
import './ManageListingsModal.css';

export default function ManageListingsModal({ show, onClose }) {
  const auth = getAuth();
  const db = getFirestore();

  const [listings, setListings] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [selected, setSelected] = useState(null);

  const fetchListings = useCallback(async () => {
    setLoading(true);
    const user = auth.currentUser;
    if (!user) return;
    const q = query(
      collection(db, 'forsale'),
      where('receiverId', '==', user.uid),
      where('status', 'in', ['unverified','active','rejected'])
    );
    const qs = await getDocs(q);
    setListings(qs.docs.map(d => ({ id: d.id, ...d.data() })));
    setLoading(false);
  }, [auth, db]);

  useEffect(() => {
    if (show) fetchListings();
  }, [show, fetchListings]);

  return (
    <>
      <Modal
        show={show}
        onHide={onClose}
        size="lg"
        centered
        scrollable
        backdropClassName="manage-backdrop"
        dialogClassName="manage-dialog modal-dialog-scrollable"
        contentClassName="manage-content"
      >
        <Modal.Header closeButton>
          <Modal.Title>My Stuff 4 Sale</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {loading ? (
            <div className="text-center py-4">
              <Spinner animation="border" />
            </div>
          ) : listings.length === 0 ? (
            <Alert variant="secondary">
              You have no listings. Tap an item to add one.
            </Alert>
          ) : (
            <ul className="manage-list">
              {listings
                .sort((a, b) => b.timestamp?.toMillis() - a.timestamp?.toMillis())
                .map(l => {
                  const thumb = l.image1 || l.image2 || l.image3 || '';
                  return (
                    <li
                      key={l.id}
                      className="manage-list-item"
                      onClick={() => setSelected(l)}
                    >
                      {thumb
                        ? <img src={thumb} alt="" className="manage-list-thumb" />
                        : <div className="manage-list-thumb-placeholder">📷</div>
                      }
                      <div className="listing-info">
                        <strong>{l.title}</strong> — ${l.price}
                        <span className={`status status-${l.status}`}>
                          {l.status === 'active'
                            ? 'Visible'
                            : l.status === 'rejected'
                            ? 'Rejected'
                            : 'Under Review'}
                        </span>
                      </div>
                    </li>
                  );
                })}
            </ul>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="outline-light" onClick={onClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {selected && (
        <ListingEditorModal
          show
          listing={selected}
          onClose={() => {
            setSelected(null);
            fetchListings();
          }}
        />
      )}
    </>
  );
}
